import React, { useState } from "react";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import isGHMC from "../../../../Common/helper/helpar";
import { MSWManagementVehiclesOnRoad } from "./MSWManagementVehiclesReport";
import { MSWManagementVehiclesMonthlyReport } from "./MSWManagementMonthlyReport";

const MSWManagementMainReport = () => {
  const currentTab = localStorage.getItem("sat-trips-active-tab");
  const [selectedTab, setSelectedTab] = useState(currentTab || 0)
  const isProd = isGHMC();
  const MSWTabClassNames = `datatable_tabs ${isProd ? selectedTab == 0 ? "active-ghmc" : "active-swm" : selectedTab == 0 ? "active-default" : "inactive-default"}`
  const MonthlyTabClassNames = `datatable_tabs ${isProd ? selectedTab == 1 ? "active-ghmc" : "active-swm" : selectedTab == 1 ? "active-default" : "inactive-default"}`
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">MSW Management Vehicles On The Road</h4>
            <div className="page-header">
              <div className="card">
                <div className="card-body">
                  <Tabs
                    defaultIndex={currentTab}
                    onSelect={(index) => {setSelectedTab(index); localStorage.setItem("sat-trips-active-tab", index)}}
                  >
                    <TabList style={{ display: "flex" }}>
                      <Tab className={MSWTabClassNames}>
                      MSW Management Vehicles On The Road - Secondary Collection
                      </Tab>
                      <Tab className={MonthlyTabClassNames}>
                      Monthly Report - MSW Management Vehicles on the Road - Secondary Collection
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <MSWManagementVehiclesOnRoad />
                    </TabPanel>
                    <TabPanel>
                      <MSWManagementVehiclesMonthlyReport />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MSWManagementMainReport;
